<template>  
    <div class="accordion-item">  
      <div class="accordion-header" @click="toggle">
       <slot name="header">
           {{header}}
       </slot>
        
        <!-- {{ header }} -->
        <span v-if="isRight">

            <i class="el-collapse-item__arrow el-icon-arrow-right" v-if="!isOpen"></i>
            <i class="el-collapse-item__arrow el-icon-arrow-down" v-else></i>
        </span>
      </div>  
      <div class="accordion-body" v-show="isOpen&&isRight">  
        <slot></slot> <!-- 使用slot来放置折叠内容 -->  
      </div>  
    </div>  
  </template>  
    
  <script>  
  export default {  
    name: 'AccordionItem',  
    props: ['header','isRight'],  
    data() {
      return {  
        isOpen: false,
      };  
    },
    methods: {  
      toggle(event) {
        if(this.isRight) event.stopPropagation(); 
        this.isOpen = !this.isOpen;  
      },  
    },  
  }  
  </script>  
    
  <style scoped>  
  .accordion-item {  
    /* border: 1px solid #ccc;   */
    /* margin-bottom: 10px;   */
  }  
    
  .accordion-header {  
    text-align: left;
    /* background-color: #f8f9fa;   */
    border-bottom: solid 1px #ccc;
    padding: 10px;
    cursor: pointer;  
    font-size: 16px;
    height: 20px;
    color: black;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }  
    
  .accordion-body { 
    text-align: left;
    padding: 10px;
    font-size: 12px;
    font-weight: 500;
  }  
  .accordion-body p{
    font-size: 14px;
  }
  </style>